import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { setRecoil } from 'recoil-nexus';
import styled from 'styled-components';
import DropdownSelect, { SelectType } from '../components/DropdownSelect';
import AddMultiStoreModal from '../components/modal/AddMultiStoreModal';
import NoticeController from '../controller/NoticeController';
import StoreController, { AdverHotelType, StoreType } from '../controller/StoreController';
import { requestNotificationPermission } from '../firebase';
import { AuthContext } from '../navigation/AuthProvider';
import { messageCountState, messageState } from '../recoil/fcmMessage';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import MobileSidebar from './sidebar/MobileSidebar';
import Sidebar from './sidebar/Sidebar';

type titleType = {
  title: string;
  content: string;
};
interface AccordionItem {
  title: string;
  link?: string;
  content?: { link: string; title: string }[];
}

let countTemp = 0;
let oWindow: Window | null = null;

export const ProtectedLayout = (oProps: any) => {
  const navigate = useNavigate();

  const userAgent = navigator.userAgent.toLowerCase();

  const { userInfo, currentStore, url, handleLogout } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [visibleMultiStoreModal, setVisibleMultiStoreModal] = useState<boolean>(false);

  const [currentTitle, setCurrentTitle] = useState<titleType>({ title: '', content: '' });
  const [multiStoreInfo, setMultiStoreInfo] = useState<SelectType[]>([currentStore]);
  const [defaultStoreInfo, setDefaultStoreInfo] = useState<SelectType>(currentStore);

  const [isUnReadNotice, setIsUnreadNotice] = useState<boolean>(false);

  const [notAdverCount, setNotAdverCount] = useState<number>(0);

  const location = useLocation();

  const checkHotelAccount = () => {
    return userInfo && userInfo.store_list.find((item: any) => item.store_type === 4)
      ? true
      : false;
  };

  const accordionData: (AccordionItem | undefined)[] = [
    // {
    //   title: '홈',
    //   link: '/sales/monthly',
    // },
    {
      title: '판매/정산 관리',
      content: [
        { link: '/sales/period', title: '기간별매출' },
        { link: '/sales/settle', title: '정산내역' },
        { link: '/store/salemanager', title: '주문접수 관리' },
      ],
    },
    {
      title: '상품 등록/관리',
      content: [
        { link: '/advertise/category', title: '업종 선택' },
        { link: '/product/product', title: '상품등록 관리' },
        { link: '/product/category', title: '상품분류 관리' },
        { link: '/product/option', title: '상품옵션 관리' },
        { link: '/product/setmenu', title: '세트등록 관리' },
        { link: '/product/setitem', title: '세트구성 관리' },
        { link: '/product/coupon', title: '쿠폰관리' },
      ],
    },
    {
      title: '영업 관리',
      content: [
        { link: '/store/time', title: '영업시간' },
        { link: '/store/holiday', title: '매장휴무' },
      ],
    },
    {
      title: '광고 관리',
      content: [
        { link: '/advertise/upload', title: '광고 사진/영상 등록' },
        { link: '/advertise/status', title: '호텔 입점 관리' },
      ],
    },
    {
      title: '매장 정보 설정',
      content: [
        { link: '/store/info', title: '매장정보' },
        { link: '/store/delivery', title: '배달정보' },
        { link: '/store/testOrder', title: '테스트 주문' },
        { link: '/ceo/info', title: '사업자 정보' },
      ],
    },
    checkHotelAccount()
      ? {
          title: '위탁상품관리',
          content: [{ link: '/product/timeproduct', title: '직영/위탁 상품' }],
        }
      : undefined,
    // {
    //   title: '공지사항',
    //   link: '/notification/list',
    // },
    // {
    //   title: '테스트',
    //   link: '/test',
    // },
  ];

  const getAccordionTitle = () => {
    for (let i = 0; i < accordionData.length; i++) {
      if (accordionData[i]) {
        if (accordionData[i]!.content) {
          for (let j = 0; j < accordionData[i]!.content!.length; j++) {
            if (location.pathname.indexOf(accordionData[i]!.content![j].link) !== -1) {
              return {
                title: accordionData[i]!.title,
                content: accordionData[i]!.content![j].title,
              };
            }
          }
        } else {
          if (location.pathname.indexOf(accordionData[i]!.link!) !== -1) {
            return { title: '', content: accordionData[i]!.title };
          }
        }
      }
    }
    return { title: '', content: '' };
  };

  // select list 불러오기
  const getStoreList = async () => {
    const userData = await AsyncLocalStorage.getItem('ceo-userData');
    // console.log('userData', userData, 'userInfo', userInfo, currentStore);
    let storeListTemp: SelectType[] = [];
    // console.log('storeData', userData.store_list);
    if (userData) {
      userData?.store_list?.map((item: StoreType, index: number) => {
        if (item.store_type === 1 || item.store_type === 4) {
          storeListTemp.push({
            key: index,
            value: item.store_id,
            name: item.store_name,
            label: item.store_name,
          });
        }
      });
      setMultiStoreInfo([...storeListTemp]);
    }
    // console.log('defaultStoreInfo', defaultStoreInfo);
  };

  const getUnreadCount = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oRes = await NoticeController.getUnreadCount(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getlist', oResponse);
        if (oResponse.data) {
          setIsUnreadNotice(oResponse.data.unreadCount > 0);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const getHotelStore = async () => {
    const oParams = {
      store_id: defaultStoreInfo.value,
    };
    const oResponse = await StoreController.getHotelStore(oParams);
    if (oResponse && oResponse.data) {
      const oRes = oResponse.data;
      if (oRes.data) {
        setNotAdverCount(
          oRes.data.filter((item: AdverHotelType) => !item.is_ad && item.confirm_type === undefined)
            .length,
        );
        console.log(
          'notAdverCount',
          oRes.data.filter(
            (item: AdverHotelType) => !item.is_ad && item.confirm_type === undefined,
          ),
        );
      }
    }
  };

  // 선택한 select store 정보 저장
  const selectStoreInfo = async (e: any) => {
    AsyncLocalStorage.setItem('ceo-currentStore', JSON.stringify(e));
    // console.log('select', userData.store_list[e.key], e);
    setDefaultStoreInfo(e);
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const checkCurrentStore = async () => {
    const currentStore = await AsyncLocalStorage.getItem('ceo-currentStore');
    if (!currentStore) {
      handleLogout();
    }
  };

  // currentStore 변경되면 defaultValue 변경
  const onChangeDefaultValue = async () => {
    getStoreList();
    const current_store = await AsyncLocalStorage.getItem('ceo-currentStore');
    if (current_store) setDefaultStoreInfo(current_store);
  };

  useEffect(() => {
    onChangeDefaultValue();
    getUnreadCount();
  }, [currentStore]);

  useEffect(() => {
    getHotelStore();
  }, [defaultStoreInfo]);

  useEffect(() => {
    getStoreList();

    if (!userInfo) {
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 50);
    }
  }, [userInfo]);

  useEffect(() => {
    if (location.pathname.indexOf('/store/salemanager') !== -1 && 'salemanager') {
      countTemp = 0;
      setRecoil(messageCountState, 0);
    } else if (location.pathname.indexOf('/notification/list') !== -1) {
      setIsUnreadNotice(false);
    }
    setCurrentTitle(getAccordionTitle());

    // if (!/kakaotalk/i.test(userAgent)) {
    checkCurrentStore();
    // }
  }, [location]);

  // FCM
  useEffect(() => {
    const receiveData = async (event: any) => {
      const receivedData = event.data;

      setRecoil(messageState, new Date().getTime().toString());
      if (
        receivedData.data.update_order_status === '0' ||
        (receivedData.data.confirmed_by === '1' && receivedData.data.update_order_status === '1')
      ) {
        countTemp += 1;
        // setMessageCount(messageCount + 1);
        setRecoil(messageCountState, countTemp);

        console.log('Background Message received.\n', event, '\n', receivedData, countTemp);
      }
    };

    requestNotificationPermission();
    if ('serviceWorker' in navigator) {
      console.log('serviceWorker');
      navigator.serviceWorker.addEventListener('message', receiveData);

      return () => {
        navigator.serviceWorker.removeEventListener('message', receiveData);
      };
    }
  }, []);

  // New page
  const loadNewWindow = () => {
    oWindow = window.open(`${process.env.REACT_APP_API_CEO_URL}`, '_blank');
  };

  // if (!userInfo) {
  //   if (navigator.userAgent.includes('KAKAOTALK')) {
  //     window.location.assign('/');
  //   }
  //   return <Navigate to="/" />;
  // }
  return (
    <MainStyle>
      <div className="layoutWrap">
        <div className="mobileHeader">
          <MobileSidebar
            toggle={toggle}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            {...oProps}
            accordionData={accordionData}
            currentStore={defaultStoreInfo}
            currentTitle={currentTitle}
            loadNewWindow={loadNewWindow}
            checkHotelAccount={checkHotelAccount}
            isUnReadNotice={isUnReadNotice}
            notAdverCount={notAdverCount}
          />
        </div>
        <div className="screen">
          <div className="leftWrap">
            <Sidebar
              currentStore={defaultStoreInfo}
              accordionData={accordionData}
              currentTitle={currentTitle}
              loadNewWindow={loadNewWindow}
              checkHotelAccount={checkHotelAccount}
              isUnReadNotice={isUnReadNotice}
              notAdverCount={notAdverCount}
              {...oProps}
            />
          </div>
          <div className="rightWrap" onClick={() => setIsOpen(false)}>
            {location.pathname.indexOf('/ceo/info') !== -1 ||
            location.pathname.indexOf('/dashboard') !== -1 ? (
              <></>
            ) : (
              <div
                className={`headerWrap ${
                  location.pathname.indexOf('/sales/calendar') !== -1 && 'wide'
                }`}>
                <div className="categoryTitle">
                  <h3>{currentTitle.title}</h3>
                  {currentTitle.title !== '' && <span>&gt;</span>}
                  <h2>{currentTitle.content}</h2>
                </div>
                <div
                  className={`headerButtonWrap ${
                    location.pathname.indexOf('/store/salemanager') !== -1 && 'salemanager'
                  }`}>
                  {location.pathname.indexOf('/product') !== -1 && (
                    <button
                      className="menuView"
                      onClick={() => {
                        if (process.env.REACT_APP_ENV === 'PRD') {
                          window.open(
                            `https://knock.ivid.co.kr/store/${defaultStoreInfo.value}`,
                            '_blank',
                            'width=800,height=1280',
                          );
                        } else {
                          window.open(
                            `http://192.168.168.57:3000/store/${defaultStoreInfo.value}`,
                            '_blank',
                            'width=800,height=1280',
                          );
                        }
                      }}>
                      메뉴 보기
                    </button>
                  )}
                  <div className="row">
                    {location.pathname.indexOf('/store/salemanager') === -1 && (
                      <button
                        className="addMultiStore"
                        onClick={() => setVisibleMultiStoreModal(true)}>
                        <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="add" />
                      </button>
                    )}
                    {defaultStoreInfo ? (
                      <DropdownSelect
                        options={multiStoreInfo}
                        defaultValue={defaultStoreInfo}
                        onChangeValue={selectStoreInfo}
                        icon={
                          location.pathname.indexOf('/store/salemanager') !== -1
                            ? undefined
                            : 'ic_arrow_down_green'
                        }
                      />
                    ) : (
                      <div
                        className="selector none"
                        onClick={() => setVisibleMultiStoreModal(true)}>
                        매장을 등록해주세요
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <Outlet
              context={{
                currentStore: defaultStoreInfo!,
                setCurrentStore: setDefaultStoreInfo,
              }}
            />
          </div>
        </div>
      </div>
      <AddMultiStoreModal
        isVisible={visibleMultiStoreModal}
        setVisible={setVisibleMultiStoreModal}
      />
    </MainStyle>
  );
};

export const MainStyle = styled.div`
  /* 모바일 */
  .mobileHeader {
    display: none;
  }

  /* screen */
  .screen {
    width: 100vw;
    max-width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: flex-start;
  }

  .layoutWrap {
    width: 100%;
    -webkit-user-select: none; /* Chrome, Safari, Edge */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* 일반적인 방법 */
    background: red !important;
  }
  /* 고정 사이드바 */
  .leftWrap {
    min-width: 250px;
    max-width: 250px;
    background: #2b2b2b;
    min-height: 100dvh;
    height: auto;
    z-index: 99;
  }

  /* 오른쪽 화면 공통사항 */
  .rightWrap {
    flex: 1;
    min-height: 100dvh;
    padding: 27px 46px;
    background: #f7f7f7;
  }

  /* headerWrap */
  .headerWrap {
    width: 800px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .categoryTitle {
    display: flex;
    align-items: center;
    h2 {
      font-size: 20px;
      font-weight: 700;
      color: #555;
    }
    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #979797;
    }
    span {
      margin: 0 10px;
      color: #979797;
      font-weight: 500;
    }
  }
  .headerWrap.wide {
    width: 1000px;
  }
  .headerButtonWrap {
    position: absolute;
    display: flex;
    gap: 17px;
    right: 0;
    top: 0;
    padding: 23px 46px;

    h2 {
      font-size: 16px;
      font-weight: 600;
      color: #40977f;
    }
    button {
      padding: 8px 19px;
      border-radius: 5px;
    }

    .selector {
      width: 100%;
      min-width: 140px;
      background: #f7f7f7;
      color: #4dd2ae;
      border: 1px solid #4dd2ae;
      font-size: 16px;
      font-weight: 600;
    }
    .selectHeader {
      gap: 10px;
    }
    .selectList {
      top: 19px;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-top: none;
      .selectItem {
        background: #ffffff;
        color: #4dd2ae;
      }
      .selectItem:hover {
        background: #ecf5f3;
      }
      .selectItem.selected {
        background: #4dd2ae;
        color: #ffffff;
      }
    }
    .selector.none {
      color: #979797;
    }
  }

  /* 800px container */
  .contentContainer {
    margin: 0 auto;
    width: 800px;
    margin-top: 42px;
    padding: 47px 80px;
    background: #ffffff;
    border-radius: 10px;
  }
  .contentContainer.wide {
    width: 1000px;
  }
  .contentContainer:nth-child(2),
  .contentContainer:nth-child(3),
  .contentContainer:nth-child(4) {
    margin-top: 6px;
  }

  /* wideContainer */
  .wideContainer {
    min-width: 1300px;
    width: 100%;
    min-height: 100%;
  }

  /* 타이틀 공통사항  */
  .title h1 {
    margin-bottom: 26px;
    font-size: 28px;
    color: #3b4044;
  }
  /* 저장버튼 공통사항 */
  .submitButtonWrap {
    position: sticky;
    bottom: 0;
    padding: 15px 0 30px 0;
    background: #fff;
    margin-top: auto !important;
  }

  /* tab 공통사항 */
  .tab_wrap {
    width: 100%;

    .tab_line {
      width: 100%;
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    button.tab_item_btn {
      width: 15%;
      padding: 4px 10px;
      margin: 0 1%;
      background: #fafafa;
      border: none;
      outline: none;
      position: relative;
      white-space: nowrap;

      h2 {
        font-size: 18px;
        padding-bottom: 2px;
        font-weight: 600;
      }
    }
  }
  .tab_line button.active {
    font-weight: 600;
    color: #000;
    border-bottom: 6px solid #4dd2ae;
  }

  /* menuView */
  .menuView {
    padding: 9px 18px !important;
    color: #4dd2ae;
    border: 1px solid #4dd2ae;
    font-size: 16px;
    font-weight: 600;
  }

  .addMultiStore {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: 1px solid #4dd2ae;
  }

  .row {
    gap: 8px;
  }

  /* 태블릿 */
  @media (max-width: 1200px) {
    .leftWrap {
      display: none;
    }
    .mobileHeader {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      background: #f7f7f7;
      padding: 24px 0 0 34px;
    }

    .rightWrap {
      padding: 80px 46px;
    }
    .headerButtonWrap {
      all: unset;
      display: flex;
      /* flex-direction: column; */
      gap: 6px;
      align-items: flex-end;
    }
  }

  /* 모바일 */
  @media (max-width: 900px) {
    .mobileHeader {
      background: #fff;
      padding: 20px 4vw 0 4vw;
    }
    .rightWrap {
      width: 100vw;
      background: #fff;
      padding: 60px 0 0 0;
    }
    .contentContainer {
      width: 100%;
      margin: 0;
      padding: 47px 3vw;
      border-radius: 0;
      border-top: 6px solid #f7f7f7;
    }
    .contentContainer:nth-child(1) {
      border-top: none;
    }
    .contentContainer.wide {
      width: 100%;
    }
    .wideContainer {
      min-width: auto;
    }
    .headerWrap {
      width: 100%;
      padding: 0 3vw;
      justify-content: flex-end;

      .categoryTitle {
        display: none;
      }
      .headerButtonWrap {
        display: flex;
        .selector {
          background: #ffffff;
        }
      }
      .headerButtonWrap.salemanager {
        width: 100%;
        margin-bottom: 16px;
        .selector {
          min-width: 94vw;
          color: #979797;
          border: 1px solid #cecece;
          padding: 14px 16px 14px 26px;
          font-size: 18px;
          font-weight: 600;

          .selectList {
            top: 28px;
            padding: 0;
            border: 1px solid #979797;
            border-top: none;
            .selectItem {
              padding: 10px 26px;
              font-weight: 500;
              font-size: 16px;
              background: #ffffff;
              color: #979797;
            }
            .selectItem:hover {
              background: #cecece;
            }
            .selectItem.selected {
              background: #979797;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
`;
